import store from '@/store'

export default [
  {
    path: '/auth',
    name: 'auth',
    redirect: { name: 'login' },
    component: () => import('@/components/Layouts/Auth.vue'),
    meta: {
      title: 'Login',
      sort: 0,
      authenticatable: false,
      icon: 'mdi-account-key',
    },
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('../Signin.vue'),
        meta: {
          title: 'Sign In',
          sort: 0,
          icon: 'mdi-account-key',
        },
        beforeEnter: (to, from, next) => {
          const isAuthenticated = store.getters['auth/isAuthenticated']

          if (isAuthenticated) {
            return next({name: 'dashboard'})
          } else {
            localStorage.removeItem('user')
            localStorage.removeItem('token')
          }

          return next()
        },
      },
      {
        path: '/signup',
        name: 'signup',
        component: () => import('../Signup.vue'),
        meta: {
          title: 'Sign Up',
          sort: 0,
          icon: 'mdi-account-key',
        },
        beforeEnter: (to, from, next) => {
          const isAuthenticated = store.getters['auth/isAuthenticated']

          if (isAuthenticated) {
            return next({name: 'dashboard'})
          }

          return next()
        },
      },
      {
        path: '/logout',
        name: 'logout',
        beforeEnter: (to, from, next) => {
          store.dispatch('auth/logout')
            .then(response => {
              window.location.reload()
            })
        },
      },
      {
        path: '/welcome',
        name: 'welcome',
        component: () => import('../cards/Usertype.vue'),
      },
      {
        path: '/reset-password',
        name: 'password.reset',
        component: () => import('../ResetPassword.vue'),
        meta: {
          title: 'Reset Password',
          sort: 0,
          icon: 'mdi-account-key',
        },
        beforeEnter: (to, from, next) => {
          const isAuthenticated = store.getters['auth/isAuthenticated']

          if (isAuthenticated) {
            return next({name: 'dashboard'})
          }

          return next()
        },
      },

      {
        path: '/password/reset',
        name: 'password.resetform',
        component: () => import('../PasswordResetForm.vue'),
        meta: {
          title: 'Reset Password',
          sort: 0,
          icon: 'mdi-account-key',
        },
        beforeEnter: (to, from, next) => {
          const isAuthenticated = store.getters['auth/isAuthenticated']

          if (isAuthenticated) {
            return next({name: 'dashboard'})
          }

          return next()
        },
      },
    ],
  },
];
